module.exports = __webpack_public_path__ + "img/AFMS_PANIC_OFF.e81f1e9a.png";